import { Button, Modal } from '@resurs/midas-react'
import QRCode from 'qrcode.react'
import React from 'react'
import { getText } from '../../../internal/TextLabels'
import styles from './QRModal.module.scss'

const QRModal = ({
  showNext = true,
  show,
  title,
  description,
  value,
  onClose,
  onNext,
}) => (
    <Modal
      show={show}
      hideClose
      onClose={() => undefined}
      actions={
        <div className={styles.modalActions} style={{ justifyContent: showNext ? 'space-between' : 'center' }}>
          <Button type="secondary" onClick={onClose}>
            {getText('default.close')}
          </Button>

          {value &&
            (value.includes('test.resurs.loc') ||
              value.includes('integration.resurs.com') ||
              value.includes('localhost')) && (
              <a
                href={value}
                rel="noopener noreferrer"
                target="_blank"
              >
                Mocka
              </a>
            )}

          {showNext && (
            <Button
              type="primary"
              text={getText('default.next')}
              onClick={onNext}
            />
          )}
        </div>
      }
    >
      <div className={styles.container}>
        <div className={styles.title}
        >
          {title}
        </div>
        <div className={styles.qrSection}
        >
          {description}
          {value && <QRCode value={value} size={300}/>}
        </div>
      </div>

    </Modal>
  )

export default QRModal
